// Phase NOTARY-FOCUS N9.1 — Pricing matrix derived from NOTARY_ACTS
// Single source of truth for visible PricingTable + Offer schema.
// Adds MFA / Apostille / Embassy add-ons for transparency.
import { NOTARY_ACTS } from "./notary-acts";

export interface NotaryPriceRow {
  slug: string;
  nameTh: string;
  nameEn: string;
  category: string;
  notaryFee: number;     // THB
  turnaround: string;
  mfaAddon?: number;     // optional MFA legalization
  apostilleAddon?: number;
  embassyAddonFrom?: number;
  popular?: boolean;
}

export const NOTARY_PRICE_ROWS: NotaryPriceRow[] = NOTARY_ACTS.map((a) => ({
  slug: a.slug,
  nameTh: a.nameTh,
  nameEn: a.nameEn,
  category: a.category,
  notaryFee: a.priceFromTh,
  turnaround: a.turnaround,
  mfaAddon: 800,
  apostilleAddon: 1500,
  embassyAddonFrom: 1200,
  popular: [
    "certify-signature", "certified-true-copy", "copy-passport",
    "affidavit", "affidavit-single", "power-of-attorney",
    "specific-poa", "travel-consent", "certify-translation",
  ].includes(a.slug),
}));

export const NOTARY_PRICE_BUNDLE = [
  {
    id: "notary-only",
    nameTh: "Notary เท่านั้น",
    nameEn: "Notary only",
    descTh: "ค่ารับรองโดยทนายผู้ทำคำรับรอง",
    descEn: "Notarial Services Attorney fee",
    priceTh: "500–2,500",
    priceEn: "THB 500–2,500",
  },
  {
    id: "notary-mfa",
    nameTh: "Notary + MFA",
    nameEn: "Notary + MFA Legalization",
    descTh: "เพิ่มประทับตรากระทรวงต่างประเทศไทย",
    descEn: "Add Thai Ministry of Foreign Affairs stamp",
    priceTh: "1,300–3,300",
    priceEn: "THB 1,300–3,300",
  },
  {
    id: "notary-apostille",
    nameTh: "Notary + Apostille (Hague)",
    nameEn: "Notary + Apostille (Hague 2025)",
    descTh: "สำหรับ 30+ ประเทศสมาชิก Hague Convention",
    descEn: "For 30+ Hague Convention member countries",
    priceTh: "2,000–4,000",
    priceEn: "THB 2,000–4,000",
  },
  {
    id: "notary-embassy",
    nameTh: "Notary + Embassy Legalization",
    nameEn: "Notary + Embassy Legalization",
    descTh: "สำหรับประเทศนอก Hague (จีน, UAE, ซาอุฯ ฯลฯ)",
    descEn: "For non-Hague countries (CN, UAE, SA, etc.)",
    priceTh: "2,200–5,500",
    priceEn: "THB 2,200–5,500",
  },
] as const;

export const NOTARY_PRICE_RANGE = {
  low: Math.min(...NOTARY_PRICE_ROWS.map((r) => r.notaryFee)),
  high: 5500, // includes embassy bundle ceiling
  count: NOTARY_PRICE_ROWS.length,
};
